import { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/auth-context";
import { useNavigate } from "react-router-dom";
import Toggle from "../layout/Toggle";
import makeFlyerTemplateOne from "../util/makeFlyerTemplateOne";
import makeFlyerTemplateTwo from "../util/makeFlyerTemplateTwo";
import makeFlyerTemplateThree from "../util/makeFlyerTemplateThree";
import makeFlyerTemplateFour from "../util/makeFlyerTemplateFour";
import makeFlyerTemplateFive from "../util/makeFlyerTemplateFive";
import makeFlyerTemplateSix from "../util/makeFlyerTemplateSix";
import makeFlyerTemplateSeven from "../util/makeFlyerTemplateSeven";
import FlyerOptionsHeader from "./FlyerOptionsHeader";
import CoBrandingOptions from "./CoBrandingOptions";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function FlyerOptionsCustomizations({ hasHeadshot }) {
  const { currentUser } = useAuth();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [enableCobranding, setEnableCobranding] = useState(false);

  if (currentUser.settings === undefined || currentUser.settings === null) {
    history("/");
  }

  const [isError, setIsError] = useState(false);
  const [showMloUrlOptions, setShowMloUrlOptions] = useState(false);
  const [changed, setChanged] = useState(false);
  const [selected, setSelected] = useState({});
  const [cobrandHeadshot, setCobrandHeadshot] = useState("");
  const [flyerGenerationError, setFlyerGenerationError] = useState(false);
  const [customMloUrl, setCustomMloUrl] = useState("");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [titleError, setTitleError] = useState(false);

  const coBrandFirstName = useRef("");
  const coBrandLastName = useRef("");
  const coBrandTitle = useRef("");
  const coBrandPhone = useRef("");
  const coBrandFaxPhone = useRef("");
  const coBrandCompanyName = useRef("");
  const coBrandEmail = useRef("");
  const coBrandWebsite = useRef("");
  const inputFile = useRef("");

  useEffect(() => {
    setTimeout(() => {
      if (currentUser.settings.user.customMloWebsite === true) {
        setShowMloUrlOptions(true);
        document.getElementById("customMloUrl").value =
          currentUser.settings.user.customMloWebsiteUrl;
      }
    }, 300);
  }, []);

  // useEffect(() => {
  //   if (currentUser && currentUser.uid) {
  //     console.log("Current User ID: ", currentUser.uid);

  //     firebase
  //       .firestore()
  //       .collection("cobranders")
  //       .where("userId", "==", currentUser.uid)
  //       .get()
  //       .then((querySnapshot) => {
  //         const cobranderList = querySnapshot.docs.map((doc) => ({
  //           id: doc.id,
  //           ...doc.data(),
  //         }));
  //         setCobranders(cobranderList);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching cobranders: ", error);
  //       });
  //   }
  // }, [currentUser]);


  const validateCoBrandingFields = () => {
    let isValid = true;

    if (coBrandFirstName.current.value === "") {
      setFirstNameError(true);
      isValid = false;
    } else {
      setFirstNameError(false);
    }

    if (coBrandLastName.current.value === "") {
      setLastNameError(true);
      isValid = false;
    } else {
      setLastNameError(false);
    }

    if (coBrandTitle.current.value === "") {
      setTitleError(true);
      isValid = false;
    } else {
      setTitleError(false);
    }

    return isValid;
  };

  const handleMloUrlChange = (e) => {
    setCustomMloUrl(e.target.value);
    currentUser.settings.user.customMloWebsiteUrl = e.target.value;
    currentUser.settings.user.customMloWebsite = true;
  };

  const handleChange = (e) => {
    setIsError(false);
    setSelected(e.target.value);
    currentUser.branch = JSON.parse(e.target.value);
    currentUser.settings.user.branchAddress = JSON.parse(e.target.value);
  };

  const removeBranch = (e) => {
    e.preventDefault();
    currentUser.branch = null;
    currentUser.settings.user.branchAddress = null;
    setSelected({});
  };

  const toggleSetting = (setting) => {
    currentUser.settings.user[setting] = !currentUser.settings.user[setting];
    setChanged(!changed);
  };

  const checkErrorOrSuccess = (mode, retryCount = 0) => {
    setLoading(true);

    if (!currentUser.branch && !currentUser.settings.user.branchAddress) {
      // If the branch is not selected, set the error
      setLoading(false);
      setFlyerGenerationError(true);
      console.error("Branch is not selected");
      return;
    }

    if (currentUser.branch === undefined || currentUser.branch === null) {
      currentUser.branch = currentUser.settings.user.branchAddress;
    }

    setFlyerGenerationError(false);
    setIsError(false);

    // Validate co-branding fields if co-branding is enabled
    const isValidCoBranding = enableCobranding
      ? validateCoBrandingFields()
      : true;

    // If there are field errors, set the flyer generation error
    if (!isValidCoBranding) {
      setFlyerGenerationError(true);
      setLoading(false);

      setTimeout(() => {
        setFlyerGenerationError(false);
      }, 5000);

      return;
    }

    if (enableCobranding) {
      currentUser.settings.coBrand = {
        firstName: coBrandFirstName.current.value,
        lastName: coBrandLastName.current.value,
        title: coBrandTitle.current.value,
        phoneNumber: coBrandPhone.current.value,
        faxNumber: coBrandFaxPhone.current.value,
        companyName: coBrandCompanyName.current.value,
        email: coBrandEmail.current.value,
        website: coBrandWebsite.current.value,
        headshot: cobrandHeadshot,
      };
    }

    // Choose the flyer template and generate the flyer
    const flyerGenerationPromise = (() => {
      switch (currentUser.flyerChoice.templateId) {
        case 1:
          return makeFlyerTemplateOne(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 2:
          return makeFlyerTemplateTwo(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 3:
          return makeFlyerTemplateThree(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 4:
          return makeFlyerTemplateFour(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 5:
          return makeFlyerTemplateFive(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 6:
          return makeFlyerTemplateSix(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        case 7:
          return makeFlyerTemplateSeven(
            currentUser,
            mode,
            setLoading,
            enableCobranding,
            cobrandHeadshot
          );
        default:
          return Promise.reject("Invalid template ID");
      }
    })();

    flyerGenerationPromise
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error generating flyer: ", error);
         if (retryCount < 3) {
        console.log(`Retrying... attempt ${retryCount + 1}`);
        setTimeout(() => {
          checkErrorOrSuccess(mode, retryCount + 1);
        }, 4000); // Retry after 4 seconds
      } else {
        setFlyerGenerationError(true);
        setLoading(false);
        setTimeout(() => {
          setFlyerGenerationError(false);
        }, 5000); // 5-second timeout for flyer generation error
      }
      }
      );
  };

  useEffect(() => {
    setShowMloUrlOptions(currentUser.settings.user.mloWebsite);
    currentUser.settings.user.customMloWebsiteUrl = "";
    currentUser.settings.user.customMloWebsite = false;
  }, [changed]);

  useEffect(() => {
    if (currentUser.settings?.user.customMloWebsite) {
      setCustomMloUrl(currentUser.settings?.user.customMloWebsiteUrl);
      currentUser.settings.user.customMloWebsite = true;
    } else {
      setCustomMloUrl("");
      currentUser.settings.user.customMloWebsite = false;
    }
  }, [currentUser]);

  useEffect(() => {
    if (enableCobranding) {
      const element = document.getElementsByClassName("fade-in")[0];
      element.id = "cobrandform";
    } else {
      const element = document.getElementsByClassName("fade-in")[0];
      element.id = "";
    }
  }, [enableCobranding]);

  return (
    <div>
      <FlyerOptionsHeader />
      <div className="flex justify-around p-6 mt-6 flex-col md:flex-row">
        <div className="flex flex-col md:w-2/5 my-2 space-y-4 pb-4">
          <h2 className="text-blue-primary text-2xl underline">Your Options</h2>
          {hasHeadshot ? (
            <div className="flex ml-36 space-x-4">
              <Toggle
                toggleSetting={toggleSetting}
                value={"headshot"}
                option={currentUser.settings.user.headshot}
              />
              <p className="text-blue-primary text-xl font-semibold">
                Enable Headshot
              </p>
            </div>
          ) : null}
          <div className="flex ml-36 space-x-4">
            <Toggle
              toggleSetting={toggleSetting}
              value={"mobileNumber"}
              option={currentUser.settings.user.mobileNumber}
            />
            <p className="text-blue-primary text-xl font-semibold">
              Enable Mobile Number
            </p>
          </div>
          <div className="flex ml-36 space-x-4">
            <Toggle
              toggleSetting={toggleSetting}
              value={"faxNumber"}
              option={currentUser.settings.user.faxNumber}
            />
            <p className="text-blue-primary text-xl font-semibold">
              Enable Fax Number
            </p>
          </div>
          <div className="flex ml-36 space-x-4">
            <Toggle
              toggleSetting={toggleSetting}
              value={"mloWebsite"}
              option={currentUser.settings.user.mloWebsite}
            />
            <p className="text-blue-primary text-xl font-semibold">
              Enable MLO page website
            </p>
          </div>
          {showMloUrlOptions ? (
            <div className="w-1/2 mx-auto">
              <label
                htmlFor="customMloUrl"
                className="block text-sm font-medium text-gray-700 text-left pl-1"
              >
                Use a custom URL for your MLO page.
              </label>
              <div className="mt-0">
                <input
                  onChange={handleMloUrlChange}
                  type="text"
                  name="customMloUrl"
                  id="customMloUrl"
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-md border border-grey-300 rounded-md pl-2"
                  placeholder="https://www.loanofficer.com"
                />
                <p className="text-xs text-left pl-2 text-gray-400">
                  Leave blank to use default URL
                </p>
              </div>
            </div>
          ) : null}
          <div className="w-3/5 ml-36 pt-2">
            {currentUser.settings.user.branchAddress ? (
              <div className="mt-2">
                <h1 className="text-md font-semibold">
                  The Branch you've selected is:
                </h1>
                <p className="text-sm ">
                  {currentUser.settings.user.branchAddress.Address}
                </p>
                <h1
                  onClick={removeBranch}
                  className="underline text-green-primary cursor-pointer font-semibold"
                >
                  Click here to reset Branch address
                </h1>
              </div>
            ) : (
              <select
                value={selected}
                onChange={handleChange}
                className={classNames(
                  isError
                    ? "border-2 border-red-600"
                    : "border border-gray-300",
                  "shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-md rounded-md pl-2 text-gray-600"
                )}
              >
                <option value="">Select Your Branch</option>
                {currentUser.branches
                  .filter((branch) => {
                    let brandname = currentUser.brand.BrandName;
                    if (
                      currentUser.brand.BrandName === "The Bodner Team" ||
                      currentUser.brand.BrandName === "The Rueth Team" ||
                      currentUser.brand.BrandName === "The Spahr Team"
                    ) {
                      brandname = "OneTrust Home Loans";
                    }
                    return branch.BrandName === brandname;
                  })
                  .sort((a, b) => {
                    if (a.Address < b.Address) {
                      return -1;
                    }
                    if (a.Address > b.Address) {
                      return 1;
                    }
                    return 0;
                  })
                  .map((branch, index) => {
                    return (
                      <option key={index} value={JSON.stringify(branch)}>
                        {branch.Address}
                      </option>
                    );
                  })}
              </select>
            )}
            {isError ? (
              <p className="text-sm text-red-600 text-left pl-2">
                Please select a branch
              </p>
            ) : null}
          </div>
        </div>
        <div className="border"></div>
        <CoBrandingOptions
          enableCobranding={enableCobranding}
          setEnableCobranding={setEnableCobranding}
          currentUser={currentUser}
          coBrandFirstName={coBrandFirstName}
          coBrandLastName={coBrandLastName}
          coBrandTitle={coBrandTitle}
          coBrandPhone={coBrandPhone}
          coBrandFaxPhone={coBrandFaxPhone}
          coBrandCompanyName={coBrandCompanyName}
          coBrandEmail={coBrandEmail}
          coBrandWebsite={coBrandWebsite}
          inputFile={inputFile}
          validateCoBrandingFields={validateCoBrandingFields}
          firstNameError={firstNameError}
          lastNameError={lastNameError}
          titleError={titleError}
          cobrandHeadshot={cobrandHeadshot}
          setCobrandHeadshot={setCobrandHeadshot}
        />
      </div>
      <div>
        {loading && (
          <div className="text-md font-semibold text-blue-primary">
            <h4>Loading...</h4>
          </div>
        )}

        {flyerGenerationError && (
          <div className="text-md font-semibold text-red-primary">
            <h4>There was an error generating the flyer, please try again.</h4>
          </div>
        )}
      </div>
      <div className="space-x-5">
        <button
  onClick={function () {
    checkErrorOrSuccess("preview");
  }}
  type="button"
  className="my-6 w-1/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-lg font-medium text-black bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
>
  Preview
</button>
<button
  onClick={function () {
    checkErrorOrSuccess("download");
  }}
  type="button"
  className="my-6 w-1/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-lg font-medium text-white bg-blue-primary hover:bg-blue-complimentary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complimentary"
>
  Download
</button>
      </div>
    </div>
  );
}
